import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl25 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".white{fill:#fff;}.red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_25",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Sign",
				children: [/* @__PURE__ */ _jsx("rect", {
					className: "black",
					x: 46,
					y: 5,
					width: 13,
					height: 24,
					rx: 2.91,
					ry: 2.91
				}), /* @__PURE__ */ _jsx("path", {
					className: "white",
					d: "M56.04,25.43c-.55,0-1-.45-1-1v-1.97l-6.91-10.03c-.12-.17-.18-.36-.18-.57v-2.29c0-.55.45-1,1-1s1,.45,1,1v1.97l6.91,10.03c.12.17.18.36.18.57v2.29c0,.55-.45,1-1,1Z"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Station",
				className: "black",
				d: "M30.92,32.89c-.45,0-.86-.31-.97-.77-.13-.54.21-1.08.74-1.2,1.34-.32,2.31-1.54,2.31-2.92,0-1.65-1.35-3-3-3-.91,0-1.77.41-2.34,1.12-.34.43-.97.5-1.41.15-.43-.35-.5-.98-.15-1.41.95-1.19,2.37-1.87,3.9-1.87,2.76,0,5,2.24,5,5,0,2.33-1.58,4.33-3.85,4.86-.08.02-.16.03-.23.03ZM56,42v14.12c-.07.5-.49.88-1,.88h-20.12c-.5-.07-.88-.49-.88-1v-12.12c-.07-.5-.49-.88-1-.88h-1.12c-.5-.07-.88-.49-.88-1,0-.55.45-1,1-1h1.18c1.59.1,2.82,1.41,2.82,3v11h4V21.82c-.1-1.59-1.41-2.82-3-2.82h-14.18c-1.59.1-2.82,1.41-2.82,3h0v.12c-.07.5-.49.88-1,.88-.55,0-1-.45-1-1h0v-.22c.12-2.67,2.32-4.78,5-4.78h14.22c2.67.12,4.78,2.32,4.78,5v15h9.22c2.67.12,4.78,2.32,4.78,5ZM50,44.03v-.12c-.07-.5-.49-.88-1-.88h-2.12s-.11.03-.11.03c-.45.11-.77.51-.77.97v10.97h4v-10.97ZM54,55v-13s0-.18,0-.18c-.09-1.59-1.41-2.82-2.99-2.82h-9v16h2v-11.15c.1-1.59,1.41-2.82,3-2.82h2.18c1.59.1,2.82,1.41,2.82,3v10.97h2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Arrow",
				className: "black",
				d: "M21.92,11.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-5-5c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29h-9.59c-.55,0-1,.45-1,1s.45,1,1,1h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5-5c.09-.09.17-.2.22-.33Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Train",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M26.21,47.75c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M28.79,35.04c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM25.37,49.4c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M24.21,35.02c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM20.94,39.54c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M12.66,47.81c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M22.22,47.81c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl25;
